import React, { useState, useEffect, useContext } from 'react';
import { Alert, InputAdornment, Card, CardContent, Container, Stack, Grid, Box, FormControl, TextField, IconButton, Typography } from "@mui/material";
import Paper from '@mui/material/Paper';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useNavigate } from 'react-router-dom';
import EventIcon from '@mui/icons-material/Event';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import { AntTabs, AntTab } from '../tabs_style';
import AddIcon from '@mui/icons-material/AddCircle';
import RemoveIcon from '@mui/icons-material/RemoveCircle';
import injupemplogogobierno from '../../../img/injupemplogogobierno.png'
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Importa el archivo de localización para español
import { CalendarIcon } from '@mui/x-date-pickers/icons';

export default function MontoDelBeneficioLeyAnterior({ nombre, apellido, modulo }) {
    const [tabIndex, setTabIndex] = React.useState(3);
    const navigate = useNavigate();

    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const [rows, setRows] = useState([
        {
            id: 1,
            inicio: null,
            final: null,
            errors: {
                inicio: { fechaVacia: false, invalidFormat: false, cleared: false },
                final: { fechaVacia: false, invalidFormat: false, cleared: false }
            }
        }
    ]);

    const [dias, setDias] = useState(0);
    const [meses, setMeses] = useState(0);
    const [años, setAños] = useState(0);

    const handleAddRow = () => {
        const newRow = {
            id: rows.length + 1,
            inicio: null,
            final: null,
            errors: {
                inicio: { fechaVacia: false, invalidFormat: false, cleared: false },
                final: { fechaVacia: false, invalidFormat: false, cleared: false }
            }
        };
        setRows([...rows, newRow]);
    };

    const handleRemoveRow = (id) => {
        if (rows.length > 1) {
            if (id !== 1) {
                const updatedRows = rows.filter(row => row.id !== id);
                // Recalcula los números de fila
                const recalculatedRows = updatedRows.map((row, index) => ({ ...row, id: index + 1 }));
                setRows(recalculatedRows);
                calculateDurations(recalculatedRows);
            }
        }
    };


    const calculateDurations = (rows) => {
        let totalDias = 0;
        let totalMeses = 0;
        let totalAños = 0;

        rows.forEach(row => {
            if (row.inicio && row.final) {
                const start = dayjs(row.inicio, "DD/MM/YYYY");
                const end = dayjs(row.final, "DD/MM/YYYY");

                if (start.isValid() && end.isValid() && !end.isBefore(start)) {
                    const duration = end.diff(start, 'day');
                    totalDias += duration;
                    totalMeses += end.diff(start, 'month');
                    totalAños += end.diff(start, 'year');
                }
            }
        });

        setDias(totalDias);
        setMeses(totalMeses);
        setAños(totalAños);
    };

    const handleDateChange = (rowId, field, date) => {
        const updatedRows = rows.map(row => {
            if (row.id === rowId) {
                const newErrors = { ...row.errors[field] };

                if (!date) {
                    newErrors.fechaVacia = true;
                    newErrors.invalidFormat = false;
                } else if (!dayjs(date, "DD/MM/YYYY").isValid()) {
                    newErrors.fechaVacia = false;
                    newErrors.invalidFormat = true;
                } else {
                    newErrors.fechaVacia = false;
                    newErrors.invalidFormat = false;

                    if (field === 'final' && row.inicio && dayjs(date, "DD/MM/YYYY").isBefore(dayjs(row.inicio, "DD/MM/YYYY"))) {
                        newErrors.invalidRange = true;
                    } else if (field === 'inicio' && row.final && dayjs(row.final, "DD/MM/YYYY").isBefore(dayjs(date, "DD/MM/YYYY"))) {
                        row.errors.final.invalidRange = true;
                    } else {
                        newErrors.invalidRange = false;
                        row.errors.final.invalidRange = false;
                    }
                }

                return {
                    ...row,
                    [field]: date,
                    errors: {
                        ...row.errors,
                        [field]: newErrors
                    }
                };
            }
            return row;
        });

        setRows(updatedRows);
        calculateDurations(updatedRows);
    };

    const handleClearDate = (rowId, field) => {
        const updatedRows = rows.map(row => {
            if (row.id === rowId) {
                return {
                    ...row,
                    [field]: null,
                    errors: {
                        ...row.errors,
                        [field]: { ...row.errors[field], cleared: true }
                    }
                };
            }
            return row;
        });

        setRows(updatedRows);
        calculateDurations(updatedRows);
    };

    const handleBlurDate = (rowId, field) => {
        const updatedRows = rows.map(row => {
            if (row.id === rowId) {
                const newErrors = { ...row.errors[field] };
                if (!row[field]) {
                    newErrors.fechaVacia = true;
                    newErrors.invalidFormat = false;
                }
                return {
                    ...row,
                    errors: {
                        ...row.errors,
                        [field]: newErrors
                    }
                };
            }
            return row;
        });

        setRows(updatedRows);
        calculateDurations(updatedRows);
    };

    function CustomDatePickerTabla({ rowId, field, label, selectedDate, errors, ...props }) {
        const today = dayjs();

        useEffect(() => {
            if (errors.cleared) {
                const timeout = setTimeout(() => {
                    setRows(rows.map(row => {
                        if (row.id === rowId) {
                            return {
                                ...row,
                                errors: {
                                    ...row.errors,
                                    [field]: { ...row.errors[field], cleared: false }
                                }
                            };
                        }
                        return row;
                    }));
                }, 1500);

                return () => clearTimeout(timeout);
            }
            return () => { };
        }, [errors.cleared, rowId, field]);

        const handleDateChangeWrapper = (date) => {
            handleDateChange(rowId, field, date);
        };

        const handleBlurWrapper = () => {
            handleBlurDate(rowId, field);
        };

        const handleKeyDown = (event) => {
            event.preventDefault();
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                        format={"DD/MM/YYYY"}
                        value={selectedDate}
                        views={['year', 'month', 'day']}
                        onAccept={handleDateChangeWrapper}
                        label={label}
                        slotProps={{
                            field: { clearable: true, onClear: () => handleClearDate(rowId, field) },
                            textField: {
                                helperText: errors.fechaVacia ? `Seleccione la ${label}` :
                                    errors.invalidFormat ? "Formato de fecha incorrecto" :
                                        (selectedDate && dayjs(selectedDate).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" :
                                            errors.invalidRange ? "La Fecha Final no puede ser menor que la Fecha Inicio" : null),
                                error: errors.fechaVacia || errors.invalidFormat || errors.invalidRange,
                                onKeyDown: handleKeyDown,
                                onBlur: handleBlurWrapper
                            },
                        }}
                        maxDate={today}
                        {...props}
                    />
                </DemoItem>
                {errors.cleared && (
                    <Alert
                        sx={{ position: 'absolute', bottom: 0, right: 0 }}
                        severity="success"
                    >
                        Fecha Borrada!
                    </Alert>
                )}
            </LocalizationProvider>
        );
    }

    function CustomDatePickerNacimiento({ label, selectedDate, setSelectedDate, errors, setErrors, ...props }) {
        const today = dayjs();

        React.useEffect(() => {
            if (errors.cleared) {
                setSelectedDate(null);
                const timeout = setTimeout(() => {
                    setErrors(prev => ({ ...prev, cleared: false }));
                }, 1500);

                return () => clearTimeout(timeout);
            }
            return () => { };
        }, [errors.cleared, setSelectedDate, setErrors]);

        const handleDateChange = (date) => {
            if (!date) {
                setErrors({ fechaVacia: true, invalidFormat: false, cleared: false });
            } else if (!dayjs(date, "DD/MM/YYYY").isValid()) {
                setErrors({ fechaVacia: false, invalidFormat: true, cleared: false });
            } else {
                setErrors({ fechaVacia: false, invalidFormat: false, cleared: false });
                setSelectedDate(date);
            }
        };

        const handleBlur = () => {
            if (!selectedDate) {
                setErrors(prev => ({ ...prev, fechaVacia: true, invalidFormat: false }));
            }
        };

        const handleKeyDown = (event) => {
            event.preventDefault(); // Evitar la entrada manual
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                        format={"DD/MM/YYYY"}
                        value={selectedDate}
                        views={['year', 'month', 'day']}
                        onAccept={handleDateChange}
                        label={label}
                        slotProps={{
                            field: { clearable: true, onClear: () => setErrors(prev => ({ ...prev, cleared: true })) },
                            textField: {
                                helperText: errors.fechaVacia ? `Seleccione la ${label}` : errors.invalidFormat ? "Formato de fecha incorrecto" : (selectedDate && dayjs(selectedDate).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" : null),
                                error: errors.fechaVacia || errors.invalidFormat,
                                onKeyDown: handleKeyDown,
                                onBlur: handleBlur
                            },
                        }}
                        maxDate={today}
                        {...props}
                    />
                </DemoItem>
                {errors.cleared && (
                    <Alert
                        sx={{ position: 'absolute', bottom: 0, right: 0 }}
                        severity="success"
                    >
                        Fecha Borrada!
                    </Alert>
                )}
            </LocalizationProvider>
        );
    }

    // Estado de los datepicker
    const [FechaSolicitud, setFechaSolicitud] = React.useState(null);
    const [FechaSolicitudErrors, setFechaSolicitudErrors] = React.useState({
        fechaVacia: false,
        invalidFormat: false,
        cleared: false
    });

    const [FechaNacimiento, setFechaNacimiento] = React.useState(null);
    const [FechaNacimientoErrors, setFechaNacimientoErrors] = React.useState({
        fechaVacia: false,
        invalidFormat: false,
        cleared: false
    });

    const [errors, setErrors] = React.useState({});

    const handleBlur = (event) => {
        const fieldName = event.target.id;
        const fieldValue = event.target.value;
        let errorMessage = '';

        const fieldNamesToMessages = {
            ValorActual: "Ingrese el valor actual de las cotizaciones",
            YearsTotales: "Ingrese los años totales",
            YearsTotalesManual: "Ingrese los años totales (manual)",
            t: "Ingrese t",
            hrs: "Ingrese hrs",
            FactorRescate: "Ingrese factor de rescate",
            TotalCotizaciones: "Ingrese Total Cotizaciones por factor de rescate antes de las aplicaciones de oficio"
        };

        if (fieldNamesToMessages.hasOwnProperty(fieldName)) {
            if (fieldValue.length < 1) {
                errorMessage = fieldNamesToMessages[fieldName];
            }
        }

        setErrors(prevErrors => ({
            ...prevErrors,
            [fieldName]: errorMessage
        }));
    };
    return (
        <>
            <Grid container direction="column" alignItems="center">
                <Container>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <h2>Monto Del Beneficio</h2>
                    </div>
                </Container>
                <Container>
                    <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Paper square>
                            <AntTabs
                                value={tabIndex}
                                onChange={handleChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                                TabIndicatorProps={{
                                    style: { display: 'none' }, // O también puedes usar display: 'none' aquí
                                }}
                            >
                                <AntTab label="Resumen" />
                                <AntTab label="Tabla De Interés" />
                                <AntTab label="Tasas Por Año" />
                                <AntTab label="Monto Del Beneficio" />
                                <AntTab label="Datos" />
                                <AntTab label="Cálculos" />
                                <AntTab label="Rebajas" />
                                <AntTab label="Períodos" />
                                <AntTab label="Comparativa Devolución 10%" />
                                <AntTab label="Con Reingreso" />
                            </AntTabs>
                        </Paper>
                    </Box>

                    <Box mt={3}>
                        {/* Contenido de la pestaña actual */}
                        {tabIndex === 0 && navigate('/Separaciones/ResumenLeyAnterior')}
                        {tabIndex === 1 && navigate('/Separaciones/TablaDeInteresLeyAnterior')}
                        {tabIndex === 2 && navigate('/Separaciones/TasasLeyAnterior')}
                        {tabIndex === 3}
                        {tabIndex === 4 && navigate('/Separaciones/LeyAnterior')}
                        {tabIndex === 5 && navigate('/Separaciones/CalculosLeyAnterior')}
                        {tabIndex === 6 && navigate('/Separaciones/RebajasLeyAnterior')}
                        {tabIndex === 7 && navigate('/Separaciones/PeriodosLeyAnterior')}
                        {tabIndex === 8 && navigate('/Separaciones/ComparativaLeyAnterior')}
                        {tabIndex === 9 && navigate('/Separaciones/ConReingresoLeyAnterior')}

                    </Box>
                </Container>
            </Grid>

            <Box marginTop={2} boxShadow={2}>
                <Card variant='outlined'>
                    <CardContent>
                        <Stack direction="row" marginTop={1}>
                            <Grid container spacing={1}>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="NombreParticipante"
                                        label="Nombre Participante"
                                        variant="outlined"
                                        disabled
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <AccountBoxIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="Cotizante"
                                        label="Cotizante"
                                        variant="outlined"
                                        disabled
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="ValorActual"
                                        label="Valor Actual De Las Cotizaciones"
                                        variant="outlined"
                                        error={Boolean(errors.ValorActual)}
                                        onBlur={handleBlur}
                                        helperText={errors.ValorActual}
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>

                        <Stack direction="row" marginTop={1}>
                            <Grid container spacing={1}>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="FechaCese"
                                        label="Fecha del Cese de Labores"
                                        variant="outlined"
                                        disabled
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <EventIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <CustomDatePickerNacimiento
                                        id="FechaSolicitud"
                                        label="Fecha de Solicitud"
                                        selectedDate={FechaSolicitud}
                                        setSelectedDate={setFechaSolicitud}
                                        errors={FechaSolicitudErrors}
                                        setErrors={setFechaSolicitudErrors}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="EdadTrece"
                                        label="Edad Cumplida en el 2013"
                                        variant="outlined"
                                        disabled
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>

                        <Stack direction="row" marginTop={1}>
                            <Grid container spacing={1}>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <CustomDatePickerNacimiento
                                        id="FechaNacimiento"
                                        label="Fecha de Nacimiento"
                                        selectedDate={FechaNacimiento}
                                        setSelectedDate={setFechaNacimiento}
                                        errors={FechaNacimientoErrors}
                                        setErrors={setFechaNacimientoErrors}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="EdadCese"
                                        label="Edad de la Persona al Cese"
                                        variant="outlined"
                                        disabled
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="EdadActual"
                                        label="Edad Actual de la Persona"
                                        variant="outlined"
                                        disabled
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>
                    </CardContent>
                </Card>
            </Box>

            <Box marginTop={3} boxShadow={2}>
                <Card variant='outlined'>
                    <CardContent>
                        <Stack direction="row" alignItems="center" marginBottom={2}>
                            <IconButton onClick={handleAddRow} title="Agregar Celda">
                                <AddIcon style={{ color: 'green', fontSize: '30px' }} />
                            </IconButton>
                            <Typography variant="h6"><strong>Períodos</strong></Typography>
                        </Stack>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>Período</strong></TableCell>
                                        <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>Fecha Inicio Período</strong></TableCell>
                                        <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>Fecha Final Período</strong></TableCell>
                                        <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>Eliminar</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell style={{ textAlign: 'center', fontSize: 16 }}>
                                                <label><strong>{row.id}</strong></label>
                                            </TableCell>
                                            <TableCell>
                                                <CustomDatePickerTabla
                                                    rowId={row.id}
                                                    field='inicio'
                                                    label="Fecha Inicio"
                                                    selectedDate={row.inicio}
                                                    errors={row.errors.inicio}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <CustomDatePickerTabla
                                                    rowId={row.id}
                                                    field='final'
                                                    label="Fecha Final"
                                                    selectedDate={row.final}
                                                    errors={row.errors.final}
                                                />
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                <IconButton onClick={() => handleRemoveRow(row.id)} title="Remover Celda" disabled={row.id === 1}>
                                                    <RemoveIcon style={{ color: row.id === 1 ? 'gray' : 'red', fontSize: '30px' }} />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box display="flex" justifyContent="center" alignItems="center" marginTop={4}>
                            <Stack direction="row" spacing={2}>
                                <Box display="flex" alignItems="center">
                                    <Typography marginRight={1} fontWeight="bold">Días:</Typography>
                                    <TextField
                                        variant="filled"
                                        value={dias}
                                        InputProps={{
                                            readOnly: true,
                                            sx: { textAlign: 'center' }
                                        }}
                                        inputProps={{
                                            style: { textAlign: 'center' }
                                        }}
                                        sx={{ width: '80px' }}
                                    />
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <Typography marginRight={1} fontWeight="bold">Meses:</Typography>
                                    <TextField
                                        variant="filled"
                                        value={meses}
                                        InputProps={{
                                            readOnly: true,
                                            sx: { textAlign: 'center' }
                                        }}
                                        inputProps={{
                                            style: { textAlign: 'center' }
                                        }}
                                        sx={{ width: '80px' }}
                                    />
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <Typography marginRight={1} fontWeight="bold">Años:</Typography>
                                    <TextField
                                        variant="filled"
                                        value={años}
                                        InputProps={{
                                            readOnly: true,
                                            sx: { textAlign: 'center' }
                                        }}
                                        inputProps={{
                                            style: { textAlign: 'center' }
                                        }}
                                        sx={{ width: '80px' }}
                                    />
                                </Box>
                            </Stack>
                        </Box>
                    </CardContent>
                </Card>
            </Box>

            <Box marginTop={3} boxShadow={2}>
                <Card variant='outlined'>
                    <Container>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <h2><b>Tiempo Cotizado</b></h2>
                        </div>
                    </Container>
                    <CardContent>
                        <Stack direction="row">
                            <Grid container spacing={1}>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="Dias"
                                        label="Días"
                                        variant="outlined"
                                        disabled
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="Meses"
                                        label="Meses"
                                        variant="outlined"
                                        disabled
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="Years"
                                        label="Años"
                                        variant="outlined"
                                        disabled
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>

                        <Stack direction="row" marginTop={1}>
                            <Grid container spacing={1}>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="YearsTotales"
                                        label="Años Totales"
                                        variant="outlined"
                                        error={Boolean(errors.YearsTotales)}
                                        onBlur={handleBlur}
                                        helperText={errors.YearsTotales}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="YearsTotalesManual"
                                        label="Años Totales (Manual)"
                                        variant="outlined"
                                        error={Boolean(errors.YearsTotalesManual)}
                                        onBlur={handleBlur}
                                        helperText={errors.YearsTotalesManual}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="t"
                                        label="t"
                                        variant="outlined"
                                        error={Boolean(errors.t)}
                                        onBlur={handleBlur}
                                        helperText={errors.t}
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>

                        <Stack direction="row" marginTop={1}>
                            <Grid container spacing={1}>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="hrs"
                                        label="hrs"
                                        variant="outlined"
                                        error={Boolean(errors.hrs)}
                                        onBlur={handleBlur}
                                        helperText={errors.hrs}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="FactorRescate"
                                        label="Factor de Rescate (F)"
                                        variant="outlined"
                                        error={Boolean(errors.FactorRescate)}
                                        onBlur={handleBlur}
                                        helperText={errors.FactorRescate}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1, width: '300px' }}>
                                    <TextField
                                        id="TotalCotizaciones"
                                        label="Total Cotizaciones por factor de rescate antes de las aplicaciones de oficio"
                                        variant="outlined"
                                        InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                        error={Boolean(errors.TotalCotizaciones)}
                                        onBlur={handleBlur}
                                        helperText={errors.TotalCotizaciones}
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>
                    </CardContent>
                </Card>
            </Box>

        </>
    );
}
